
































import Vue from 'vue';
import { fromPairs, includes, isEqual, reduce, startCase } from 'lodash';
import { BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';

import DaySelector from '@reciprocity/day-selector';

import { components, methods, props } from './common';

type option = {
  text: string;
  value: string;
};

export default Vue.extend({
  name: 'Notifications',
  components: {
    ...components,
    BFormCheckbox,
    BFormCheckboxGroup,
    DaySelector,
  },
  props,
  computed: {
    contentOptions(): option[] {
      return Object.keys(this.value.content).map(name => ({
        text: startCase(name),
        value: name,
      }));
    },
    selectedContent: {
      get(): string[] {
        const options = reduce(
          this.value.content,
          (acc: string[], status: boolean, name: string): string[] => {
            if (status) {
              acc.push(name);
            }
            return acc;
          },
          []
        );
        return options;
      },
      set(newSelection: string[]) {
        if (!isEqual(newSelection, this.selectedContent)) {
          this.update({
            content: fromPairs(Object.keys(this.value.content).map(name => [name, includes(newSelection, name)])),
          });
        }
      },
    },
  },
  methods,
});
